module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Burt C. Hopkins\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Burt C. Hopkins is Professor of Philosophy at Seattle University. He is author of Intentionality in Husserl and Heidegger and The Philosophy of Husserl. He is founding editor (with Steven G. Crowell) of The New Yearbook for Phenomenology and Phenomenological Philosophy and is permanent secretary of the Husserl Circle.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KWpaDo/tc-custom/9780253005274.jpg?1737330979234",
      "alt": "This image is the cover for the book Origin of the Logic of Symbolic Mathematics, Studies in Continental Thought"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Origin of the Logic of Symbolic Mathematics, Studies in Continental Thought\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Burt C. Hopkins presents the first in-depth study of the work of Edmund Husserl and Jacob Klein on the philosophical foundations of the logic of modern symbolic mathematics. Accounts of the philosophical origins of formalized concepts—especially mathematical concepts and the process of mathematical abstraction that generates them—have been paramount to the development of phenomenology. Both Husserl and Klein independently concluded that it is impossible to separate the historical origin of the thought that generates the basic concepts of mathematics from their philosophical meanings. Hopkins explores how Husserl and Klein arrived at their conclusion and its philosophical implications for the modern project of formalizing all knowledge.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0